import React from 'react';

import ContentCarousel from 'rebook/apps/base/components/ContentCarousel';
import UserBookshelf from 'rebook/apps/users/components/UserBookshelf';

import styles from './style.scss';


const UserBookshelvesList = ({ bookshelves, userId }) => (
  <div className="jest-latest-user-bookset">
    <ContentCarousel visibleElements={3}>
      {bookshelves && bookshelves.map((bookshelf) => (
        <UserBookshelf
          extraClassName={styles.bookshelfItem}
          bookshelf={bookshelf}
          key={bookshelf.id}
          userId={userId} />
      ))}
    </ContentCarousel>
  </div>
);

export default UserBookshelvesList;
